import { render, staticRenderFns } from "./updateEmployeeAvailabilitiesDialog.vue?vue&type=template&id=58df29ea"
import script from "./updateEmployeeAvailabilitiesDialog.vue?vue&type=script&lang=ts"
export * from "./updateEmployeeAvailabilitiesDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports